import React, { useState } from "react";
import "./CareersSection.css";
import CareerApplicationForm from './CareerApplicationForm';
import { FaChevronRight } from "react-icons/fa";

const baseCategories = [
  { name: "VCNR Healthcare" },
  { name: "VCNR Technologies" },
  { name: "VCNR Builders & Infrastructure" },
  { name: "VCNR Agrotech" },
  { name: "VCNR Foundation" },
  { name: "VCNR Golds and Diamonds" },
  { name: "VCNR Hospitalities" },
];

const jobs = [
  // Healthcare
  {
    category: "VCNR Healthcare",
    title: "Nurse",
    tags: ["Tartu", "Full-time"],
    description: "Provide patient care and support in our healthcare facilities.",
    link: "#"
  },
  {
    category: "VCNR Healthcare",
    title: "Doctor",
    tags: ["Tartu", "Full-time"],
    description: "Diagnose and treat patients, lead medical teams.",
    link: "#"
  },
  {
    category: "VCNR Healthcare",
    title: "Community Health Worker",
    tags: ["Tartu", "Full-time"],
    description: "Engage with communities to promote health and wellness.",
    link: "#"
  },
  // Technologies
  {
    category: "VCNR Technologies",
    title: "Frontend Developer",
    tags: ["Remote", "Full-time"],
    description: "Build and maintain user interfaces for web applications.",
    link: "#"
  },
  {
    category: "VCNR Technologies",
    title: "UI/UX Designer",
    tags: ["Remote", "Full-time"],
    description: "Design user experiences and interfaces for digital products.",
    link: "#"
  },
  {
    category: "VCNR Technologies",
    title: "AI Researcher",
    tags: ["Remote", "Full-time"],
    description: "Research and develop AI models for innovative solutions.",
    link: "#"
  },
  // Builders & Infrastructure
  {
    category: "VCNR Builders & Infrastructure",
    title: "Civil Engineer",
    tags: ["Bangalore", "Full-time"],
    description: "Plan and oversee construction projects.",
    link: "#"
  },
  {
    category: "VCNR Builders & Infrastructure",
    title: "Project Manager",
    tags: ["Bangalore", "Full-time"],
    description: "Lead project teams and ensure timely delivery.",
    link: "#"
  },
  {
    category: "VCNR Builders & Infrastructure",
    title: "Site Supervisor",
    tags: ["Bangalore", "Full-time"],
    description: "Supervise on-site activities and ensure safety compliance.",
    link: "#"
  },
  // Agrotech
  {
    category: "VCNR Agrotech",
    title: "Agricultural Engineer",
    tags: ["Mysore", "Full-time"],
    description: "Develop and implement agricultural technology solutions.",
    link: "#"
  },
  {
    category: "VCNR Agrotech",
    title: "Farm Manager",
    tags: ["Mysore", "Full-time"],
    description: "Oversee daily operations of agricultural farms.",
    link: "#"
  },
  {
    category: "VCNR Agrotech",
    title: "Sustainable Agriculture Specialist",
    tags: ["Mysore", "Full-time"],
    description: "Promote and implement sustainable farming practices.",
    link: "#"
  },
  // Foundation
  {
    category: "VCNR Foundation",
    title: "Program Coordinator",
    tags: ["Bangalore", "Full-time"],
    description: "Coordinate and manage foundation programs and events.",
    link: "#"
  },
  {
    category: "VCNR Foundation",
    title: "Social Worker",
    tags: ["Bangalore", "Full-time"],
    description: "Support community welfare and outreach initiatives.",
    link: "#"
  },
  {
    category: "VCNR Foundation",
    title: "Fundraising Manager",
    tags: ["Bangalore", "Full-time"],
    description: "Lead fundraising campaigns and donor relations.",
    link: "#"
  },
  // Golds and Diamonds
  {
    category: "VCNR Golds and Diamonds",
    title: "Jewelry Sales Associate",
    tags: ["Bangalore", "Full-time"],
    description: "Assist customers and drive sales in our jewelry stores.",
    link: "#"
  },
  {
    category: "VCNR Golds and Diamonds",
    title: "Goldsmith",
    tags: ["Bangalore", "Full-time"],
    description: "Design and craft custom gold jewelry pieces.",
    link: "#"
  },
  {
    category: "VCNR Golds and Diamonds",
    title: "Diamond Grader",
    tags: ["Bangalore", "Full-time"],
    description: "Grade and evaluate diamonds for quality and value.",
    link: "#"
  },
  // Hospitalities
  {
    category: "VCNR Hospitalities",
    title: "Hotel Manager",
    tags: ["Mysore", "Full-time"],
    description: "Oversee hotel operations and guest services.",
    link: "#"
  },
  {
    category: "VCNR Hospitalities",
    title: "Chef",
    tags: ["Mysore", "Full-time"],
    description: "Lead kitchen staff and manage food preparation.",
    link: "#"
  },
  {
    category: "VCNR Hospitalities",
    title: "Housekeeping Supervisor",
    tags: ["Mysore", "Full-time"],
    description: "Supervise housekeeping staff and maintain facility standards.",
    link: "#"
  },
];

const JOBS_PER_PAGE = 3;

function scrollToForm() {
  const el = document.getElementById('career-application-form');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export default function CareersSection() {
  const [activeCategory, setActiveCategory] = useState(`All positions (${jobs.length})`);
  const [page, setPage] = useState(1);

  const categories = [
    { name: `All positions (${jobs.length})` },
    ...baseCategories
  ];

  const isAllPositions = activeCategory.startsWith("All positions");
  const filteredJobs =
    isAllPositions
      ? jobs
      : jobs.filter((job) => job.category === activeCategory);

  // Pagination logic for 'All positions'
  const totalPages = isAllPositions ? Math.ceil(jobs.length / JOBS_PER_PAGE) : 1;
  const paginatedJobs = isAllPositions
    ? jobs.slice((page - 1) * JOBS_PER_PAGE, page * JOBS_PER_PAGE)
    : filteredJobs;

  // Reset page to 1 when category changes
  React.useEffect(() => {
    setPage(1);
  }, [activeCategory]);

  return (
    <section className="careers-section">
      <h2 className="careers-title">We Have {jobs.length} Open Positions Now!</h2>
      <div className="careers-content">
        <aside className="careers-sidebar">
          <ul className="careers-categories">
            {categories.map((cat) => (
              <li
                key={cat.name}
                className={activeCategory === cat.name ? "active" : ""}
                onClick={() => setActiveCategory(cat.name)}
              >
                {cat.name}
              </li>
            ))}
          </ul>
          <div className="careers-desc">
            We’re hiring across experience levels. Whether you’re just entering the workforce or an experienced individual, you’ll find opportunities that align with your passion and expertise.
          </div>
          <button className="careers-btn" onClick={scrollToForm}>Submit Your Application</button>
        </aside>
        <main className="careers-jobs">
          {paginatedJobs.map((job, idx) => (
            <div className="careers-job-card" key={idx}>
              <div className="careers-job-header">
                <h3>{job.title}</h3>
                <div className="careers-job-tags">
                  {job.tags.map((tag) => (
                    <span key={tag} className="careers-job-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="careers-job-desc">{job.description}</div>
              <a href="#career-application-form" className="careers-job-link" onClick={e => { e.preventDefault(); scrollToForm(); }}>
                Apply Now <span className="arrow"><FaChevronRight /></span>
              </a>
            </div>
          ))}
          {/* Pagination controls for All positions */}
          {isAllPositions && totalPages > 1 && (
            <div className="careers-pagination">
              <button
                className="careers-btn"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                Prev
              </button>
              <span className="careers-pagination-info">
                Page {page} of {totalPages}
              </span>
              <button
                className="careers-btn"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </main>
      </div>
      <div id="career-application-form">
        <CareerApplicationForm/>
      </div>
    </section>
  );
} 